import { Instagram, Facebook, Linkedin, Youtube, MapPin } from "lucide-react";
import { site } from "@/data/site";
import { Reveal } from "./Reveal";

const LINKS = [
    { key: "instagram", Icon: Instagram, label: "Instagram" },
    { key: "facebook", Icon: Facebook, label: "Facebook" },
    { key: "linkedin", Icon: Linkedin, label: "LinkedIn" },
    { key: "youtube", Icon: Youtube, label: "YouTube" },
    { key: "google", Icon: MapPin, label: "Google" },
];

export const StayConnected = () => {
    const active = LINKS.filter((l) => site.social[l.key]);
    return (
        <section
            id="connect"
            data-testid="stay-connected-section"
            className="bg-ivory px-6 py-20 lg:px-10 lg:py-24"
        >
            <div className="mx-auto max-w-[1400px]">
                <Reveal>
                    <div className="flex flex-col items-center border-y border-line py-14 text-center lg:py-20">
                        <span className="eyebrow">Stay Connected</span>
                        <h2 className="mt-5 max-w-2xl font-serif text-3xl leading-[1.12] tracking-tight text-charcoal sm:text-4xl lg:text-5xl">
                            Follow the Swastik Realty journal of
                            <span className="italic text-orange"> luxury living.</span>
                        </h2>
                        <p className="mt-5 max-w-md text-base leading-relaxed text-slatey">
                            Market insight, new launches and curated addresses — shared first
                            with our community.
                        </p>
                        <div className="mt-9 flex items-center gap-4">
                            {active.map(({ key, Icon, label }) => (
                                <a
                                    key={key}
                                    href={site.social[key]}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label={label}
                                    data-testid={`connect-${key}`}
                                    className="flex h-12 w-12 items-center justify-center rounded-full border border-line text-charcoal transition-colors duration-300 hover:border-orange hover:bg-orange hover:text-white"
                                >
                                    <Icon size={19} strokeWidth={1.5} />
                                </a>
                            ))}
                        </div>
                    </div>
                </Reveal>
            </div>
        </section>
    );
};
